import { I18n } from '@calendly/i18n';
import { IconUsers } from '@calendly/ui/components/glyphs/IconUsers';
import { BareItem, Menu } from '@calendly/ui/components/menu';
import { BodyText } from '@calendly/ui/components/typography';
import { UiIcon } from '@calendly/ui/components/ui-icon';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { MembershipInfo } from 'features/user_info';
import { GroupIconContainer } from '../access_list/styles';
const menuCss = "m1o8xmz4";
const StyledMenu = forwardRef((props, ref) => <Menu ref={ref} {...props} data-testid="recipients-suggestions" className={classNames(menuCss, props.className)} />);
const headerCss = "h16fx9e0";
const stateCss = "suy9j6w";
const groupRowCss = "gkwor1f";
const groupTextCss = "g7spe0r";
const GroupRow = ({
  userGroup
}) => <div className={groupRowCss}>
    <GroupIconContainer>
      <UiIcon icon={IconUsers} size="small" title="" />
    </GroupIconContainer>
    <div className={groupTextCss}>
      <BodyText weight="bold">{userGroup.name}</BodyText>
      <BodyText color="muted" size="small">
        {I18n.t('publisher.meeting_recap.share_modal.access_list.group_members', {
        count: userGroup.user_group_relationships_count
      })}
      </BodyText>
    </div>
  </div>;
const SuggestionRow = ({
  suggestion
}) => {
  if (suggestion.type === 'user_group') {
    return <GroupRow userGroup={suggestion.entity} />;
  }
  return <MembershipInfo membership={suggestion.entity} isAvatarNonInteractive />;
};
export const SuggestionsDropdown = ({
  suggestions,
  isSearching,
  hasQuery,
  onSelect
}) => {
  if (isSearching) {
    return <StyledMenu>
        <div className={stateCss}>
          <BodyText color="muted">
            {I18n.t('publisher.meeting_recap.share_modal.picker.searching')}
          </BodyText>
        </div>
      </StyledMenu>;
  }
  if (!suggestions.length) {
    if (!hasQuery) {
      return null;
    }
    return <StyledMenu>
        <div className={stateCss}>
          <BodyText color="muted">
            {I18n.t('publisher.meeting_recap.share_modal.picker.not_found')}
          </BodyText>
        </div>
      </StyledMenu>;
  }
  return <StyledMenu>
      {!hasQuery && <div className={headerCss}>
          <BodyText color="muted" weight="bold" size="small">
            {I18n.t('publisher.meeting_recap.share_modal.picker.suggested')}
          </BodyText>
        </div>}
      {suggestions.map(suggestion => <BareItem key={suggestion.id} role="option" data-testid={`recipients-suggestion-${suggestion.id}`} onMouseDown={event => event.preventDefault()} onClick={() => onSelect(suggestion)}>
          <SuggestionRow suggestion={suggestion} />
        </BareItem>)}
    </StyledMenu>;
};

require("./suggestions_dropdown.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./suggestions_dropdown.js");